import React, { Component, Fragment } from 'react';
import ClassNames from 'classnames';
import Moment from 'moment';
import { withRouter } from 'react-router';

import { DateRangePicker, SingleDatePicker } from 'react-dates';
import { connect } from 'react-redux';
import Input from 'Components/Input';
import ActionLoader from 'Components/ActionLoader/index';
import {
   SERVICE_TYPES,
   SERVICE_MODES,
   INSURANCE_BY,
   RFQ_NAME_AUTOPOPULATE,
   CONTRACTING_TYPE,
   CONTRACTING_CATEGORY_TYPE,
   SERVICE_FTL,
   ACC,
   SERVICE_TYPE_CATEGORIES,
   HIKAL,
   CENTURY_PLY,
   CARGIL,
   ROQUETTE,
   CARGIL_FTL_CONTRACT_TYPE_LIST,
   BACARDI,
   DEEPAK_PHENOLICS,
   DEEPAK_PHENOLICS_SAP,
   CONTAINER_SERVICE_MODE_CATEGORIES
} from 'Constants/commonConstants';
import { SAVE_EXTEND_DATE_DETAILS, GET_PRICING_BASIS, GET_PRODUCT_CATEGORIES, GET_PACKING_TYPES ,UPLOAD_DOCUMENT} from 'Constants/actionConstants';
import { ReactComponent as RFQInfo } from 'Icons/rfqinfo.svg';
import Select from 'react-select';
import Checkbox from 'Components/Checkbox/index';
import { getUser } from 'Utils/storage';
import ReactTooltip from 'react-tooltip';
import Cx from 'classnames';

const serviceTypeToModeMapping = {
    1: [5],
    2: [1, 2, 3, 4],
    3: [4, 5],
    4: [5],
    5: [1, 2, 3, 4],
    6: [1, 2, 3, 4]
 };
 const rfqTypeToServiceTypeMapping = {
    12: [1, 2, 3, 4, 5],
    13: [4, 5],
    14: [4, 5],
    15: [4, 5]
 }
class RFQInformation extends Component {
    constructor(props) {
        super(props);
        this.rfqDetails = props.rfqDetails;
        this.rfq = props.rfq;
        this.biddingDetails = props.rfq.biddingDetails;
  
        this.state = {
           nameVal: '',
           rfqDetails: this.rfqDetails,
        }
        this.viewMode = props.viewMode;
    }

    componentDidMount() {
        const user= getUser();
        const { dispatch, rfqType, selectedNavBranch } = this.props;
        const params = {
           rfqType: rfqType,
           companyId: user.id,
           branchId: (selectedNavBranch || {}).branch_id || user.branchId
        }
        dispatch({
           type: GET_PRICING_BASIS,
           data: params
        })
        dispatch({
           type: GET_PRODUCT_CATEGORIES,
           data: params
        })
        dispatch({
           type: GET_PACKING_TYPES,
           data: params
        })
    }

    changeRFQName = (e) => {
        if (this.viewMode) {
           return;
        }
        let val = e.target.value;
        this.rfqDetails.setName(val);
        this.setState({
           nameVal: val,
           rfqDetails: this.rfqDetails
        })
        this.props.onChange();
    }

    shouldRenderServiceMode = (serviceMode) => {
        const serviceType = this.rfqDetails.serviceType;
        const { rfqType } = this.props;
        return (rfqType === 12 ? serviceTypeToModeMapping[serviceType] : (([13, 14, 15].includes(rfqType) && this.rfqDetails.serviceCategoryType === 2) ? [11] : [6, 8]));
     }
     shouldRenderServiceType = (serviceType) => {
        const { rfqType } = this.props;
        return (rfqTypeToServiceTypeMapping[rfqType].indexOf(serviceType) > -1)
     }

     toggleServiceType = (option) => {
        if (this.viewMode) {
           return;
        }
        const serviceTypeValue = option.value;
        this.rfqDetails.setServiceType(serviceTypeValue, option.name);
        this.rfqDetails.setServiceModes([]);
        let startDate = !this.rfqDetails.contractTenureTo ? Moment(this.rfqDetails.contractTenureFrom || null) : Moment(this.rfqDetails.contractTenureFrom);
        let endDate = null;
        this.rfqDetails.setContractTenureFrom(startDate);
        this.rfqDetails.setContractTenureTo(endDate);
        this.setState({
           rfqDetails: this.rfqDetails
        });
        if (serviceTypeValue === 4) {
           endDate = Moment(startDate).add(6, 'days');
           this.rfqDetails.setContractTenureFrom(startDate.valueOf());
           this.rfqDetails.setContractTenureTo(endDate.valueOf());
           this.setState({
              rfqDetails: this.rfqDetails
           })
        }
          if(![3, 4, 5].includes(serviceTypeValue)){
              const { dispatch } = this.props;
              dispatch({
                  type: GET_PRICING_BASIS,
              })
          } else {
              const { dispatch, rfqType } = this.props;
              dispatch({
                  type: GET_PRICING_BASIS,
                  data: {
                      rfqType: rfqType,
                      serviceType: serviceTypeValue === 4 ? 5 : serviceTypeValue
                  },
              })
        } 
        if (serviceTypeValue === 1 || serviceTypeValue === 4) {
           this.rfqDetails.setServiceModes([5]);
        }
        this.props.onChange();
     }

     toggleServiceMode = (option) => {
        if (this.viewMode) {
           return;
        }
        const serviceModeValue = (option || []).map(el => el.value);
        // const serviceModesSelected = [...this.rfqDetails.serviceModes];
        // const index = serviceModesSelected.indexOf(serviceModeValue);
        // if (index < 0) {
        //    serviceModesSelected.push(serviceModeValue);
        // } else {
        //    serviceModesSelected.splice(index, 1);
        // }
        this.rfqDetails.setServiceModes(serviceModeValue);
        this.setState({
           rfqDetails: this.rfqDetails
        })
        this.props.onChange();
     }

     calculateMovmentType = () => {
        const { rfqDetails } = this.state;
        const { contractTenureList } = this.props;
        if (rfqDetails.contractTenureFrom && rfqDetails.contractTenureTo) {
           const momentFrom = Moment(rfqDetails.contractTenureFrom);
           const momentTo = Moment(rfqDetails.contractTenureTo);
           const duration = Moment.duration(momentTo.diff(momentFrom));
           // let days = duration.days() + 1;
           const days = Math.floor(duration.asDays());
  
           if (duration.months() > 0 || days >= 0) {
              let type = 1;
              let typeName = "";
              if(contractTenureList && contractTenureList.length > 0 && rfqDetails.serviceType !== 4) {
                 let isDone = false;
                 (contractTenureList || []).map(el => {
                    if(el.uom === 'weeks') {
                       el.fromRange = el.fromRange * 7;
                       el.toRange = el.toRange && (el.toRange * 7) || el.toRange;
                    } else if(el.uom === 'months') {
                       el.fromRange = el.fromRange * 30;
                       el.toRange = el.toRange && (el.toRange * 30) || el.toRange;
                    }
                    if(days >= el.fromRange && (el.toRange ? days <= el.toRange : true) && !isDone) {
                       isDone = true;
                       typeName = el.contract_type;
                       type = el.contract_type_id;
                    }
                 })
              } else if(rfqDetails.serviceType === 4) {
                 if(days >= 1 && days <= 7) {
                    type = 2;
                    typeName = "Short";
                 } else if(days > 7) {
                    type = 4;
                    typeName = "Long";
                 }
              } else {
                 switch (true) {
                    case (duration.months() === 0 && days === 1 && rfqDetails.serviceType !== 4):
                       typeName = "Spot";
                       break;
  
                    case (duration.months() === 0 && (days >= 2 && days <= 7) && rfqDetails.serviceType !== 4):
                       typeName = "Short";
                       break;
  
                    case (duration.months() === 0 && (days >= 8 && days <= 31) && rfqDetails.serviceType !== 4):
                       typeName = "Monthly";
                       break;
                    case (days > 31 && rfqDetails.serviceType !== 4):
                    case (duration.months() > 0 && rfqDetails.serviceType !== 4):
                       typeName = "Long";
                       break;
  
                    case (duration.months() === 0 && (days >= 1 && days <= 7) && rfqDetails.serviceType === 4):
                       type = 5;
                       typeName = "Short";
                       break;
  
                    case (duration.months() === 0 && (days > 7) && rfqDetails.serviceType === 4):
                       type = 6;
                       typeName = "Long";
                       break;
  
                    default:
                       type = -1;
                       break;
                 }
              }
              rfqDetails.setMovementType(type, typeName);
           }
  
        } else {
           rfqDetails.setMovementType(-1, "");
        }
        return rfqDetails.movementTypeName;
     }

     checkIsRangeOutSide = (contractFromDate, date) => {
        return Moment(date) <= Moment(new Date().setHours(0,0,0,0));
     }

     selectInsuranceBy = (option) => {
        if (this.viewMode) {
           return;
        }
        const insuranceByValue = option.name;
        this.rfqDetails.setInsuranceBy(insuranceByValue);
        this.setState({
           rfqDetails: this.rfqDetails
        });
        this.props.onChange();
     }

    setShippingType = (shippingType) => {
        if (this.viewMode) {
            return;
        }
        this.rfqDetails.setShippingType(shippingType);
        this.setState({
            rfqDetails: this.rfqDetails
        })
        this.props.onChange();
    }

    setServiceCategoryType = (type) => {
        if (this.viewMode) {
           return;
        }
        this.rfqDetails.setServiceCategoryType(type.value, type.name);
        this.setState({
           rfqDetails: this.rfqDetails
        });
    }

    setOtherCosts = () => {
        if (this.viewMode) {
            return;
        }
        this.rfqDetails.setOtherCosts(!this.rfqDetails.otherCosts)
        this.setState({
            rfqDetails: this.rfqDetails
        })
        this.props.onChange();
    }

    componentWillUnmount() {
        localStorage.setItem('state', 'isDisable');
     }

     saveExtendDate = () => {
        const { dispatch, history, match } = this.props;
      
        if (match.params.id) {
            let payload;
            if (this.props.rfqDetails.contractTenureTo && this.props.rfqDetails.contractTenureFrom) {
                payload = {
                    contract_tenure_to: new Date(this.props.rfqDetails.contractTenureTo).setHours(23, 59, 59),
                    contract_tenure_from: new Date(this.props.rfqDetails.contractTenureFrom).setHours(0, 0, 0, 0),
                    rfq_id: match.params.id,
                    rfqType: match.params.type && Number(match.params.type),
                };    
                dispatch({
                    type: SAVE_EXTEND_DATE_DETAILS,
                    data: payload,
                });
            }
        }
      }

    setMultiLevelMovementType = (multiLevelMovementType) => {
        if (this.viewMode) {
            return;
        }
        this.rfqDetails.setMultiLevelMovementType(multiLevelMovementType);
        this.setState({
            rfqDetails: this.rfqDetails
        });
        this.props.onChange();
    }

    render() {
        const { rfqDetails, nameVal, selectedSubPlants, allSubPlants, rfq , selectedContractingType, allContractingType, allContractCategoryType, selectedContractCategoryType} = this.state;
		const { rfqDetailsSubmitted, selectedSubPlant, chaList, fuelTypes, spotContractReasons, contractTenureList, ftlContractTypeList, vendorBiddingStatus, rfqType } = this.props;
        const user = getUser();
        const isCopy = ((this.props.match || {}).params || {}).isCopy === 'copy';
        const isContractTenure = localStorage.getItem('state');
        const isEnableContractTenure = (isContractTenure === 'isEnable');

        return(
            <div className='rfqinfo ph-30 pv-30 dataVal'>
                <div className='header flex'>
                    <RFQInfo />
                    <div className='ml-10'>RFQ Information</div>
                </div>
                <div className='flex pt-20'>
                    <div className='mr-15 col-1'>
                        <div className='rfqlabel'>RFQ Name</div>
                        <Input
                            value={rfqDetails.name}
                            onChange={this.changeRFQName}
                            placeholder="Eg:Mumbai - Bangalore"
                            className={'dataVal border-black-light'}
                        />
                    </div>
                    {/* <div className='col-2 ml-15'>
                        <div className='rfqlabel'>Bound Type</div>
                        <Select/>
                    </div> */}
                </div>
                <div className='flex pt-20'>
                    <div className={Cx('mr-15', {
                        'col-2': ![13,14,15].includes(rfqType),
                        'col-1': [13,14,15].includes(rfqType),
                    })}>
                        <div className='rfqlabel'>Service Type</div>
                        <div className={Cx('', {
                            'flex col-1': [13,14,15].includes(rfqType) && rfqDetails.serviceCategoryType === 1
                            })}>
                            {[13,14,15].includes(rfqType) && <Select  
                                className={Cx('', {
                                    'col-2 mr-15': rfqDetails.serviceCategoryType === 1
                                })}
                                options={SERVICE_TYPE_CATEGORIES}
                                getOptionLabel={(option) => option.name}
                                onChange={this.setServiceCategoryType}
                                value={(SERVICE_TYPE_CATEGORIES || []).find(el => rfqDetails.serviceCategoryType === el.value)}
                            />}
                            {([13,14,15].includes(rfqType) ? rfqDetails.serviceCategoryType === 1 : true) && <Select 
                                options={(SERVICE_TYPES || []).filter(el => this.shouldRenderServiceType(el.value))}
                                getOptionLabel={(option) => option.name}
                                onChange={this.toggleServiceType}
                                value={(SERVICE_TYPES || []).find(el => rfqDetails.serviceType == el.value)}
                                className={Cx('', { 'col-2 ml-20': [13,14,15].includes(rfqType) })}
                            />}
                        </div>
                    </div>
                    {![13,14,15].includes(rfqType) && <div className='col-2 ml-15'>
                        <div className='rfqlabel'>Service Mode</div>
                        <div className={Cx('', {
                            'flex col-1': [13,14,15].includes(rfqType)
                            })}>
                            {[13,14,15].includes(rfqType) && <Select  
                                className={'col-2 mr-15'}
                                options={SERVICE_TYPE_CATEGORIES}
                                getOptionLabel={(option) => option.name}
                                onChange={this.setServiceCategoryType}
                                value={(SERVICE_TYPE_CATEGORIES || []).find(el => rfqDetails.serviceCategoryType === el.value)}
                            />}
                            <Select
                                options={(SERVICE_MODES || []).filter(el => (this.shouldRenderServiceMode() || []).includes(el.value))}
                                getOptionLabel={(option) => option.name}
                                onChange={this.toggleServiceMode}
                                isMulti
                                value={(SERVICE_MODES || []).filter(el => rfqDetails.serviceModes.includes(el.value))}
                                className={Cx('', { 'col-2': [13,14,15].includes(rfqType) })}
                            />
                        </div>
                    </div>}
                </div>
                <div className='flex pt-20'>
                    <div className='col-2 mr-15'>
                        <div className='rfqlabel'>
                            Contract Tenure <sup className='error-color fs-14'>*</sup>
                            <span className="contracttype ml-20">
                                {this.calculateMovmentType()}
                            </span>
                  {
                    ((this.props.rfq.original_rfq_id && !user.isSpotContract) ? rfqDetails.movementTypeName : this.calculateMovmentType()) && rfqDetails.serviceType !== 4 &&
                        <Fragment>
                            <a data-tip data-for='contract-tenture-tooltip'> <span className="tooltip-icon fBold">i</span> </a>
                            <ReactTooltip id='contract-tenture-tooltip' type="dark" effect="solid">
                            {contractTenureList && contractTenureList.length > 0 ?
                            <>{(contractTenureList || []).map((contract, index) => ( 
                                    <>
                                        {contract.contract_type_id !== 4 ? 
                                        <>
                                        <span>{`${contract.contract_type} : ${contract.fromRange} - ${contract.toRange} ${contract.uom}`}</span><br/>
                                        </> :
                                        <span>{`${contract.contract_type} : Above ${contract.fromRange} ${contract.uom}`}</span>}
                                    </>))}
                            </> :
                            <>
                                <span> Spot : 1 Day </span><br />
                                <span> Short : 2 - 7 Days </span><br />
                                <span> Monthly : 8 - 31 Days </span><br />
                                <span> Long : Above 31 Days </span><br />
                            </>}
                            </ReactTooltip>
                        </Fragment>
                        }
                        {
                            ((this.props.rfq.original_rfq_id && !user.isSpotContract) ? rfqDetails.movementTypeName : this.calculateMovmentType()) && rfqDetails.serviceType === 4 && 
                            <Fragment>
                                <a data-tip data-for='contract-tenture-tooltip'> <span className="tooltip-icon fBold">i</span> </a>
                                <ReactTooltip id='contract-tenture-tooltip' type="dark" effect="solid">
                                <span> Short : 0 - 7 Days </span><br />
                                <span> Long : Above 7 Days </span><br />
                                </ReactTooltip>
                            </Fragment>
                        }
                        </div>
                        <div className={Cx('flex', {
                            // 'br-5 border-error-color wt-max-content': rfqDetailsSubmitted && !rfqDetails.contractTenureTo
                        })}>
                            <DateRangePicker
                                startDate={!rfqDetails.contractTenureTo ? Moment(rfqDetails.contractTenureFrom || null) : Moment(rfqDetails.contractTenureFrom)}
                                startDateId="startDate"
                                endDate={rfqDetails.contractTenureTo ? Moment(rfqDetails.contractTenureTo) : null}
                                endDateId="endDate"
                                onDatesChange={({ startDate, endDate }) => {
                                    const startDateTime = startDate ? new Date(startDate).setHours(0, 0, 0, 0) : new Date(this.state.startDate).setHours(0, 0, 0, 0)
                                    this.rfqDetails.setContractTenureFrom(startDateTime)
                                    const endTime = endDate ? new Date(endDate).setHours(23, 59, 59) : undefined; 
                                    this.rfqDetails.setContractTenureTo(endTime ? new Date(endTime).getTime() : this.state.endDate)
                                    this.setState({
                                        rfqDetails: this.rfqDetails
                                    })
                                }}
                                focusedInput={this.state.focusedInput}
                                onFocusChange={focusedInput => this.setState({ focusedInput: true ? focusedInput : null })}
                                displayFormat={'DD MMM YYYY'}
                                noBorder={true}
                                minimumNights={0}
                                isOutsideRange={(date) => this.checkIsRangeOutSide(rfqDetails.contractTenureFrom, date)}
                                className={'wt-100p'}
                            />
                            {(isEnableContractTenure) && <button class="ml-5 bg-theme wt-20p mb-20 ht-40 br-20 fBold fs-16 white-color" onClick={this.saveExtendDate}>Save</button>}
                        </div>
                        {rfqDetailsSubmitted && !(rfqDetails.contractTenureTo) && <div className='error-color fs-14 fSemibold op-7 ml-5 mt-5'>Please Select Contract Tenure End Date</div>}
                    </div>
                    <div className='col-2 ml-15'>
                        <div className='rfqlabel'>Insurance By</div>
                        <Select 
                            options={INSURANCE_BY}
                            getOptionLabel={(option) => option.name}
                            value={(INSURANCE_BY || []).find(el => rfqDetails.insuranceBy === el.value)}
                            onChange={this.selectInsuranceBy}
                        />
                    </div>
                </div>
                <div className='flex pt-20'>
                    <div className='col-2 mr-15'>
                        <div className='rfqlabel'>Shipping Type</div>
                        <div className="flex mb-10 mt-10 rfqValue">
                           <Checkbox label="Import" checked={rfqDetails.shippingType === 1} className="mr-30" onCheck={this.setShippingType.bind(this, 1)} />
                           {/* <Checkbox label="Export" checked={rfqDetails.shippingType === 2} onCheck={this.setShippingType.bind(this, 2)} /> */}
                        </div>
                    </div>
                    {[13,14,15].includes(rfqType) && <div className='col-2 ml-15'>
                        <div className='rfqlabel'>Other Costs</div>
                        <div className="flex mb-10 mt-10 rfqValue">
                            <Checkbox label="Includes" checked={rfqDetails.otherCosts} className="mr-30" onCheck={isCopy ? null : this.setOtherCosts.bind(this, 1)} />
                            <Checkbox label="Excludes" checked={!rfqDetails.otherCosts} onCheck={isCopy ? null : this.setOtherCosts.bind(this, 2)} />
                        </div>
                    </div>}
                </div>
                {[15].includes(rfqType) && <div className='flex pt-20'>
                    <div className='col-2 mr-15'>
                        <div className='rfqlabel'>Movement Type</div>
                        <div className="flex mb-10 mt-10 rfqValue">
                           <Checkbox label="Door To Door" checked={rfqDetails.multiLevelMovementType === 1} className="mr-30" onCheck={isCopy ? null : this.setMultiLevelMovementType.bind(this, 1)} />
                           <Checkbox label="Leg Wise" checked={rfqDetails.multiLevelMovementType === 2} onCheck={isCopy ? null : this.setMultiLevelMovementType.bind(this, 2)} />
                        </div>
                    </div>
                </div>}
            </div>)
    }
}

const mapStateToProps = ({ contracting }) => {
    return {
       extendDateSubmitting: contracting.extendEditDate.dataSubmitting,
    }
 };

export default connect(mapStateToProps)(withRouter(RFQInformation));
